
    <template>
      <section class="relax-doc">
        <h1>Calendar 日历</h1>
<blockquote>
<p>以日历的方式展示数据</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>默认</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-calendar&gt;
    &lt;template #dateCell=&quot;{data}&quot;&gt;
      &lt;div v-for=&quot;item in getListData(data)&quot; class=&quot;events&quot;&gt;
        &lt;x-badge :status=&quot;item.type&quot; :text=&quot;item.content&quot;&gt;&lt;/x-badge&gt;
      &lt;/div&gt;
    &lt;/template&gt;
  &lt;/x-calendar&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    setup() {
      const getListData = ({y, m, d}) =&gt; {
        let listData;
        switch (d) {
          case '08':
            listData = [
              { type: 'warning', content: 'This is warning event.' },
              { type: 'success', content: 'This is usual event.' },
            ];
            break;
          case '10':
            listData = [
              { type: 'warning', content: 'This is warning event.' },
              { type: 'success', content: 'This is usual event.' },
              { type: 'error', content: 'This is error event.' },
            ];
            break;
          case '15':
            listData = [
              { type: 'warning', content: 'This is warning event' },
              { type: 'success', content: 'This is very long usual event....' },
              { type: 'error', content: 'This is error event 1.' },
              { type: 'error', content: 'This is error event 2.' },
              { type: 'error', content: 'This is error event 3.' },
              { type: 'error', content: 'This is error event 4.' },
            ];
            break;
          default:
        }
        return listData || [];
      }

      return {
        getListData
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { renderList: _renderList, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock, resolveComponent: _resolveComponent, createVNode: _createVNode, withCtx: _withCtx, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_badge = _resolveComponent("x-badge")
  const _component_x_calendar = _resolveComponent("x-calendar")

  return (_openBlock(), _createBlock(_component_x_calendar, null, {
    dateCell: _withCtx(({data}) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getListData(data), (item) => {
        return (_openBlock(), _createElementBlock("div", { class: "events" }, [
          _createVNode(_component_x_badge, {
            status: item.type,
            text: item.content
          }, null, 8, ["status", "text"])
        ]))
      }), 256))
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {
    setup() {
      const getListData = ({y, m, d}) => {
        let listData;
        switch (d) {
          case '08':
            listData = [
              { type: 'warning', content: 'This is warning event.' },
              { type: 'success', content: 'This is usual event.' },
            ];
            break;
          case '10':
            listData = [
              { type: 'warning', content: 'This is warning event.' },
              { type: 'success', content: 'This is usual event.' },
              { type: 'error', content: 'This is error event.' },
            ];
            break;
          case '15':
            listData = [
              { type: 'warning', content: 'This is warning event' },
              { type: 'success', content: 'This is very long usual event....' },
              { type: 'error', content: 'This is error event 1.' },
              { type: 'error', content: 'This is error event 2.' },
              { type: 'error', content: 'This is error event 3.' },
              { type: 'error', content: 'This is error event 4.' },
            ];
            break;
          default:
        }
        return listData || [];
      }

      return {
        getListData
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  